import { useState } from "react";

const tickerItems = [
  "热搜登顶前必看 · 全网扩散追踪进行时",
  "「某顶流深夜同框」正向登顶曲线冲刺",
  "评论区沦陷指数已触发高危预警",
  "一条爆料 12.6 小时走完引爆全程",
];

export default function Hero() {
  const [active, setActive] = useState(0);

  return (
    <header className="relative overflow-hidden">
      {/* 顶栏 */}
      <div className="relative z-20 bg-stone-950 text-stone-100">
        <div className="mx-auto flex max-w-[1440px] items-center justify-between px-4 md:px-6 h-14">
          <a href="#" className="flex items-center gap-2 whitespace-nowrap">
            <span className="flex h-7 w-7 items-center justify-center rounded bg-red-600 text-sm font-bold text-white">
              爆
            </span>
            <span className="font-serif text-xl font-black tracking-tight">暴走黑料</span>
            <span className="ml-2 hidden rounded border border-red-500/60 px-1.5 py-0.5 text-[10px] font-bold tracking-widest text-red-400 sm:inline-block">
              全网扩散追踪
            </span>
          </a>

          <nav className="hidden items-center gap-7 text-sm text-stone-300 md:flex">
            <a href="#" className="hover:text-white whitespace-nowrap">引爆时间线</a>
            <a href="#" className="hover:text-white whitespace-nowrap">热度榜单</a>
            <a href="#" className="hover:text-white whitespace-nowrap">扩散快讯</a>
            <a href="#" className="hover:text-white whitespace-nowrap">路径拆解</a>
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden items-center gap-1.5 text-xs text-stone-400 lg:flex">
              <i className="ri-radar-line text-red-500"></i>
              正在追踪 3 条热搜登顶路径
            </span>
            <a
              href="#"
              className="hidden whitespace-nowrap rounded-md bg-red-600 px-4 py-1.5 text-sm font-semibold text-white hover:bg-red-500 sm:inline-block"
            >
              追更提醒
            </a>
            <button
              className="flex h-8 w-8 items-center justify-center rounded-md text-lg text-stone-300 hover:bg-stone-800 md:hidden"
              aria-label="打开菜单"
            >
              <i className="ri-menu-line"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 大主视觉区：上疏，杂志封面式大字排版，配图克制 */}
      <section className="relative z-10 bg-stone-950 text-stone-100">
        <div className="pointer-events-none absolute inset-0 opacity-[0.06] [background-image:linear-gradient(#fff_1px,transparent_1px),linear-gradient(90deg,#fff_1px,transparent_1px)] [background-size:44px_44px]"></div>
        <div className="pointer-events-none absolute -right-40 top-1/2 h-[420px] w-[420px] -translate-y-1/2 rounded-full bg-red-600/20 blur-[120px]"></div>

        <div className="relative mx-auto max-w-[1440px] px-4 md:px-6 pb-10 md:pb-14 pt-10 md:pt-14">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
            {/* 左侧主视觉排版 */}
            <div className="max-w-3xl">
              <div className="flex flex-wrap items-center gap-2 text-xs tracking-widest text-red-400">
                <span className="flex items-center gap-1.5 rounded-full border border-red-500/50 bg-red-600/10 px-3 py-1">
                  <i className="ri-fire-line"></i> 引爆实时监测
                </span>
                <span className="text-stone-400">WATCHING THE SPREAD · 2026.09</span>
              </div>

              <h1 className="mt-6 font-serif text-4xl font-black leading-[1.15] tracking-tight md:text-6xl md:leading-[1.1]">
                从病毒传播到评论区沦陷，
                <br className="hidden sm:block" />
                <span className="text-red-500">再到热搜登顶</span>
                ，逐环节拆解。
              </h1>

              <p className="mt-5 max-w-2xl text-base leading-7 text-stone-300 md:text-lg">
                暴走黑料紧盯黑料快速发酵全过程。看一条爆料如何从原点落地，经历病毒传播、控评失守与转发刷屏，最终登顶热搜——完整引爆时间线，点开即掌握。
              </p>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <a
                  href="#timeline"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-red-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-red-500"
                >
                  查看引爆时间线 <i className="ri-arrow-right-line"></i>
                </a>
                <a
                  href="#board"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-stone-600 px-5 py-2.5 text-sm font-semibold text-stone-200 hover:border-stone-400"
                >
                  <i className="ri-bar-chart-2-line text-red-400"></i> 今日热度榜
                </a>
              </div>

              {/* 迷你计数条 */}
              <div className="mt-8 grid max-w-md grid-cols-3 gap-4 border-t border-stone-800 pt-5">
                <div>
                  <div className="font-serif text-2xl font-black text-white md:text-3xl">12.6h</div>
                  <div className="mt-1 text-xs text-stone-400">平均引爆→登顶</div>
                </div>
                <div>
                  <div className="font-serif text-2xl font-black text-red-500 md:text-3xl">31</div>
                  <div className="mt-1 text-xs text-stone-400">近 7 日引爆路径</div>
                </div>
                <div>
                  <div className="font-serif text-2xl font-black text-white md:text-3xl">873w</div>
                  <div className="mt-1 text-xs text-stone-400">讨论峰值</div>
                </div>
              </div>
            </div>

            {/* 右侧：爆点跟踪卡片（克制配图：仅一张抽象热力主视觉） */}
            <div className="mt-10 lg:mt-0 lg:ml-12 lg:w-[380px] lg:shrink-0">
              <div className="overflow-hidden rounded-lg border border-stone-700 bg-stone-900/70">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=abstract%20energy%20heatwave%20visualization%20with%20deep%20charcoal%20background%20and%20vivid%20vermilion%20orange%20glowing%20concentric%20waves%20and%20particles%2C%20editorial%20magazine%20style%2C%20high%20contrast%20red%20accent%20on%20dark%2C%20minimal%20composition&width=760&height=352&seq=hero-heat-2026-x1&orientation=landscape"
                    alt="话题引爆热度热力场抽象视觉"
                    className="h-full w-full object-cover"
                  />
                  <span className="absolute left-3 top-3 rounded bg-black/60 px-2 py-0.5 text-[11px] font-bold text-red-400">
                    <i className="ri-live-line"></i> LIVE · 引爆中
                  </span>
                </div>
                <div className="p-4">
                  <div className="flex items-start justify-between gap-2">
                    <div className="text-sm font-semibold leading-5 text-white">
                      某顶流综艺收工后深夜同框，粉丝连夜控评失败
                    </div>
                    <span className="whitespace-nowrap rounded bg-red-600 px-1.5 py-0.5 text-[10px] font-bold text-white">
                      热搜登顶
                    </span>
                  </div>
                  <div className="mt-3">
                    <div className="flex items-center justify-between text-[11px] text-stone-400">
                      <span>距热搜登顶路径完成度</span>
                      <span className="font-semibold text-red-400">96%</span>
                    </div>
                    <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-stone-700">
                      <div className="h-full w-[96%] rounded-full bg-gradient-to-r from-red-600 to-orange-500"></div>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center justify-between text-[11px] text-stone-400">
                    <span>热度涨幅 +312%</span>
                    <span>讨论量 61.4w</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 跑马灯式扩散刻度 */}
      <div className="relative z-10 flex items-stretch bg-red-600 text-white">
        <div className="flex shrink-0 items-center gap-1.5 bg-red-700 px-4 py-2.5 text-xs font-bold tracking-wider md:px-6">
          <i className="ri-broadcast-line animate-pulse"></i> 全网扩散追踪
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div
            className="flex h-full items-center whitespace-nowrap py-2.5 text-sm transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${active * 100}%)` }}
          >
            {tickerItems.map((t, i) => (
              <span key={i} className="flex h-full w-full items-center px-4 md:px-8" style={{ minWidth: "100%" }}>
                {t}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden shrink-0 items-center gap-1 pr-4 text-xs sm:flex">
          <button
            onClick={() => setActive((active + tickerItems.length - 1) % tickerItems.length)}
            className="flex h-6 w-6 items-center justify-center rounded-full bg-red-500 hover:bg-red-400"
            aria-label="上一条"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>
          <button
            onClick={() => setActive((active + 1) % tickerItems.length)}
            className="flex h-6 w-6 items-center justify-center rounded-full bg-red-500 hover:bg-red-400"
            aria-label="下一条"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
      </div>
    </header>
  );
}